// Stub for deriveErrorMessage
export function deriveErrorMessage(errors) {
    if (!errors || !Array.isArray(errors)) {
        return 'An error occurred';
    }
    
    return errors.map(error => error.message).join(', ');
}
